import { useInfiniteQuery } from '@tanstack/react-query';

import { fetchOCClaimComments } from '../data-provider/claim-notes';
import type { GetOCClaimCommentsRequestParams, OCClaimCommentsResponse } from '../data-provider/claim-notes/api';
import { getOCClaimInfiniteNextPageParam } from '../data-provider/utils/get-next-page';

export interface UseGetOCClaimNotesParams {
  fbOcKey: number | undefined;
  pageSize?: number;
  sortColumn?: string;
  sortDirection?: 'ASC' | 'DESC';
}

type OCClaimCommentsPage = OCClaimCommentsResponse;

export const useGetOCClaimNotes = ({
  fbOcKey,
  pageSize = 10,
  sortColumn = 'SequenceNo',
  sortDirection = 'DESC',
}: UseGetOCClaimNotesParams) => {
  return useInfiniteQuery<OCClaimCommentsPage>({
    enabled: Boolean(fbOcKey),
    getNextPageParam: getOCClaimInfiniteNextPageParam,
    initialPageParam: 1,
    queryFn: ({ pageParam = 1 }) => {
      const params: GetOCClaimCommentsRequestParams = {
        fbOcKey: Number(fbOcKey),
        pageIndex: Number(pageParam),
        pageSize,
        sortColumn,
        sortDirection,
      };
      return fetchOCClaimComments(params);
    },
    queryKey: ['claims-over-charge-comments', fbOcKey, sortColumn, sortDirection],
    select: (data) => {
      const notes = data.pages.flatMap((page) => page?.data ?? []);
      const lastPage = data.pages[data.pages.length - 1];
      const pageIndex = data.pages.length;

      return {
        ...data,
        notes,
        pageIndex,
        totalRows: Number(lastPage?.totalRows ?? 0),
      };
    },
  });
};
